// extracted by mini-css-extract-plugin
module.exports = {"content":"ModalColeta_content__1gMn3","wrap_coleta":"ModalColeta_wrap_coleta__3bOG_"};